/*
 * @Author: guojia 66291979@qq.com
 * @Date: 2024-05-09 23:08:56
 * @LastEditors: guojia 66291979@qq.com
 * @LastEditTime: 2024-05-20 16:59:21
 * @FilePath: /lobby/src/event/EventBus.js
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import { reactive } from 'vue'

const eventBus = reactive({
  events: {},
  $on(event, callback) {
    if (!this.events[event]) {
      this.events[event] = []
    }
    this.events[event].push(callback)
  },
  $emit(event, ...args) {
    if (this.events[event]) {
      this.events[event].forEach((callback) => {
        callback(...args)
      })
    }
  },
  $off(event, callback) {
    if (this.events[event]) {
      this.events[event] = this.events[event].filter((cb) => cb !== callback)
    }
  }
})

export default (app) => {
  app.config.globalProperties.$bus = eventBus
  window.bridge = eventBus
}
